import { Route, Redirect, IndexRoute, IndexRedirect } from 'react-router';
import React from 'react';

import AddPurchaseOrder from 'routes/purchases/add-purchase-order';
import Agreement from 'routes/agreement/view-agreement';
import AgreementAdd from 'routes/agreement/sub-routes/agreement-add';
import AgreementBillings from 'routes/agreement/sub-routes/agreement-billings';
import AgreementEdit from 'routes/agreement/sub-routes/agreement-edit';
import AgreementSummary from 'routes/agreement/sub-routes/agreement-summary';
import Agreements from 'routes/agreement/view-agreements';
import App from 'app';
import Billing from 'routes/billing/view-billing';
import Clients from 'routes/company/view-clients';
import Companies from 'routes/company/view-companies';
import Company from 'routes/company/view-company';
import CompanyAgreements from 'routes/company/sub-routes/company-agreements';
import CompanyEdit from 'routes/company/sub-routes/company-edit';
import CompanyForms from 'routes/company/sub-routes/company-forms';
import CompanyPeople from 'routes/company/sub-routes/company-people';
import CompanySummary from 'routes/company/sub-routes/company-summary';
import CompanyWatches from 'routes/company/sub-routes/company-watches';
import CompanyWorkOrders from 'routes/company/sub-routes/company-work-orders';
import Dashboard from 'routes/dashboards/dashboard';
import EmailList from 'routes/person/email-list';
import FormAdd from 'routes/company/sub-routes/form-add';
import FormEdit from 'routes/company/sub-routes/form-edit';
import FormResponses from 'routes/company/sub-routes/form-responses';
import Invoice from 'routes/invoice/view-invoice';
import Invoices from 'routes/invoice/view-invoices';
import People from 'routes/person/view-people';
import Person from 'routes/person/view-person';
import PersonEdit from 'routes/person/sub-routes/person-edit';
import PersonSummary from 'routes/person/sub-routes/person-summary';
import PortalChanges from 'routes/settings/view-portal-changes';
import Purchases from 'routes/purchases/view-purchases';
import Settings from 'routes/settings/view-settings';
import Ticket from 'routes/ticket/view-ticket';
import TicketEmails from 'routes/ticket/sub-routes/ticket-emails';
import TicketExpenses from 'routes/ticket/sub-routes/ticket-expenses';
import TicketFiles from 'routes/ticket/sub-routes/ticket-files';
import TicketSummary from 'routes/ticket/sub-routes/ticket-summary';
import TicketTasks from 'routes/ticket/sub-routes/ticket-tasks';
import TicketTime from 'routes/ticket/sub-routes/ticket-time';
import Tickets from 'routes/ticket/view-tickets';
import TimeReports from 'routes/time-report/view-time-reports';
import Triage from 'routes/triage/view-triage-items';
import TriageDashboard from 'routes/dashboards/triage';
import UserDashboard from 'routes/dashboards/user';
import Users from 'routes/person/view-users';
import ViewTriageForTest from 'routes/triage/view-triage-for-test';
import ViewWatches from 'routes/company/view-watches';
import WatchAdd from 'routes/company/sub-routes/watch-add';
import WatchEdit from 'routes/company/sub-routes/watch-edit';
import WorkOrderAdd from 'routes/company/sub-routes/work-order-add';
import WorkOrderEdit from 'routes/company/sub-routes/work-order-edit';
import Xboard from 'routes/company/view-xboard';


const routes = (
  <Route component={App}>
    <Route path="/admin">
      <Route path="users">
        <IndexRoute component={Users} />
        <Route path=":personId" component={Person}>
          <IndexRedirect to="summary" />
          <Route path="summary" component={PersonSummary} />
          <Route path="edit" component={PersonEdit} />
        </Route>
      </Route>
      <Route path="email-list" component={EmailList} />
      <Route path="clients" component={Clients} />
      <Route path="xboard" component={Xboard} />
      <Route path="watches">
        <IndexRoute component={ViewWatches} />
        <Route path="add" component={WatchAdd} />
      </Route>
      <Route path="triage">
        <IndexRoute component={Triage} />
        <Route path="view-pane-for-test" component={ViewTriageForTest} />
      </Route>
      <Route path="settings" component={Settings} />
      <Route path="agreements">
        <IndexRoute component={Agreements} />
        <Route path=":agreementId" component={Agreement}>
          <IndexRedirect to="summary" />
          <Route path="summary" component={AgreementSummary} />
          <Route path="billings" component={AgreementBillings} />
          <Route path="edit" component={AgreementEdit} />
        </Route>
      </Route>
    </Route>

    <Route path="/portal-updates" component={PortalChanges} />

    <Route path="/people">
      <IndexRoute component={People} />
      <Route path=":personId" component={Person}>
        <IndexRedirect to="summary" />
        <Route path="summary" component={PersonSummary} />
        <Route path="edit" component={PersonEdit} />
      </Route>
    </Route>

    <Route path="/login" component={null} />

    <Route path="/purchases">
      <IndexRoute component={Purchases} />
      <Route path="add" component={AddPurchaseOrder} />
    </Route>

    <Route path="/accounting">
      <Route path="billing" component={Billing} />
      <Route path="invoices">
        <IndexRoute component={Invoices} />
        <Route path=":invoiceId" component={Invoice} />
      </Route>
    </Route>

    <Route path="/tickets">
      <IndexRoute component={Tickets} />
      <Route path=":ticketId" component={Ticket}>
        <IndexRedirect to="summary" />
        <Route path="summary" component={TicketSummary} />
        <Route path="tasks" component={TicketTasks} />
        <Route path="time" component={TicketTime} />
        <Route path="expenses" component={TicketExpenses} />
        <Route path="emails" component={TicketEmails} />
        <Route path="files" component={TicketFiles} />
      </Route>
    </Route>

    <Route path="/companies">
      <IndexRoute component={Companies} />
      <Route path=":companyId" component={Company}>
        <IndexRedirect to="summary" />
        <Route path="summary" component={CompanySummary} />
        <Route path="agreements">
          <IndexRoute component={CompanyAgreements} />
          <Route path="add" component={AgreementAdd} />
        </Route>
        <Route path="work-orders">
          <IndexRoute component={CompanyWorkOrders} />
          <Route path="add" component={WorkOrderAdd} />
          <Route path=":workOrderId/edit" component={WorkOrderEdit} />
        </Route>
        <Route path="edit" component={CompanyEdit} />
        <Route path="people" component={CompanyPeople} />
        <Route path="forms">
          <IndexRoute component={CompanyForms} />
          <Route path="add" component={FormAdd} />
          <Route path=":formId/edit" component={FormEdit} />
          <Route path=":formId/responses" component={FormResponses} />
        </Route>
        <Route path="watches">
          <IndexRoute component={CompanyWatches} />
          <Route path="add" component={WatchAdd} />
          <Route path=":watchId/edit" component={WatchEdit} />
        </Route>
      </Route>
    </Route>

    <Route path="/time-reports">
      <IndexRoute component={TimeReports} />
    </Route>

    <Route path="/dashboard">
      <IndexRoute component={Dashboard} />
      <Route path="triage" component={TriageDashboard} />
      <Route path="user" component={UserDashboard} />
    </Route>

    {/* Old Xero expenses link to /expenses, so we don't want to remove the route altogether */}
    <Redirect from="/expenses" to="/purchases" />

    {/* Default route */}
    <Redirect from="/" to="/tickets" query={{ setDefaultQuery: true }} />
  </Route>
);

export default routes;



// WEBPACK FOOTER //
// ./app/app-routes.js